import type { SupplementProduct } from "./api";

export const SUPPLEMENT_CATEGORIES: Record<string, string> = {
  foundations: "Daily essentials",
  protein: "Protein",
  hydration: "Hydration",
  "gut-health": "Fiber & gut health",
  recovery: "Strength & recovery",
  "healthy-aging": "Healthy aging",
  sleep: "Sleep & relaxation",
};

export type SupplementSort = "featured" | "price-asc" | "price-desc" | "name";

export function isPurchasableSupplement(
  product: SupplementProduct,
): product is SupplementProduct & { priceCents: number } {
  return (
    product.available === true &&
    product.currency === "USD" &&
    typeof product.priceCents === "number" &&
    Number.isInteger(product.priceCents) &&
    product.priceCents > 0 &&
    product.priceCents <= 100_000
  );
}

export function supplementPrice(cents: number | null): string {
  return cents == null
    ? "Price unavailable"
    : new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(cents / 100);
}

export function filterSupplements(
  products: SupplementProduct[],
  search: string,
  category: string,
  sort: SupplementSort,
) {
  const terms = search.toLowerCase().trim().split(/\s+/).filter(Boolean);
  return products
    .filter(isPurchasableSupplement)
    .filter((product) => {
      const text = [
        product.title,
        product.brand,
        product.shortDescription,
        product.form,
        product.ingredients,
        SUPPLEMENT_CATEGORIES[product.category],
      ]
        .join(" ")
        .toLowerCase();
      return (
        (category === "all" || category === product.category) &&
        terms.every((term) => text.includes(term))
      );
    })
    .sort((a, b) => {
      if (sort === "name") return a.title.localeCompare(b.title);
      if (sort === "featured") return 0;
      return sort === "price-asc"
        ? a.priceCents - b.priceCents
        : b.priceCents - a.priceCents;
    });
}
